import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import _slicedToArray from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.find-index";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.search";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import UniversalReport from '@tencent/universal-report';
import atom from '@tencent/vft-atom';
import login from '@tencent/vft-common/login';
import env from '@tencent/vft-common/env';
import cookie from '@tencent/vft-common/cookie';
import KVParser from '@tencent/vft-common/KVParser';
import { getUrlParam } from '@tencent/vft-common/util';
import { getPlatform } from "../BossReport";
function createReporter(pageId) {
  var reporter = new UniversalReport({
    beacon: '0WEB05F90045KVFT',
    // 灯塔 APPKEY 或者灯塔实例
    formatMode: 1,
    contentidSet: _defineProperty({}, pageId, "".concat(pageId, "_init")),
    publicParams: {
      // 基础公共参数覆盖
      platform: env.isWeb ? 'pc' : 'phone',
      // 'phone' | 'pc' | 'tv' | 'tablet' | ''
      hardware_os: env.isPCClient ? 'windows' : env.isMac ? 'macos' : env.os,
      // 'android' | 'ios' | 'windows' | 'macos' | ''
      // 自定义公共参数
      ptag: getUrlParam('ptag'),
      aid: getUrlParam('aid'),
      url: location.href,
      ref_url: document.referrer,
      url_param: location.search.substr(1),
      domain: location.hostname,
      pt: getPlatform(),
      screen_height: window.screen.height,
      screen_width: window.screen.width,
      screen_size_class: getScreenSize(),
      hh_ua_raw: navigator.userAgent,
      hc_pvid: cookie.get('pgv_pvid') || ''
    },
    bossSet: {
      dt_pgin: {
        // 页面曝光
        AttaId: '08000035396',
        token: '6627225758'
      },
      dt_pgout: {
        // 页面结束曝光
        AttaId: '0c600035397',
        token: '5338911273'
      },
      dt_imp: {
        // 页面元素曝光
        AttaId: '07100035402',
        token: '9859947335'
      },
      dt_imp_end: {
        // 页面元素结束曝光
        AttaId: '0a100035399',
        token: '1756176621'
      },
      dt_clck: {
        // 页面元素点击
        AttaId: '0bb00035401',
        token: '4172841644'
      }
    }
  });
  return reporter;
}
var BOSS_DT_KEYMAP = {
  f_module_id: 'mod_id',
  // 模块id
  f_module: 'mod_title',
  // 模块标题
  f_resource: 'btn_title',
  // 按钮标题
  f_module_type: 'e_module_type',
  // 模块类型
  f_hottag: 'dt-eid' // 元素id
};

export default function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    reportBoss: true
  };
  var reporter = createReporter(options.pageId);
  var instance = {
    reporter: reporter,
    bind: function bind(el, binding, vnode) {
      binding.value = parseParams(binding.value, options.reportBoss);
      setParams(el, binding.value, vnode);
    },
    update: function update(el, binding, vnode) {
      binding.value = parseParams(binding.value, options.reportBoss);
      setParams(el, binding.value, vnode);
    },
    setPublicParams: function () {
      var _setPublicParams = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, baseParams;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = options && options.extraParams ? options.extraParams() : {};
                _context.next = 3;
                return getBaseParams();
              case 3:
                baseParams = _context.sent;
                atom.getMainCookie().then(function (cookies) {
                  reporter.setPublicParams(_objectSpread(_objectSpread({
                    hc_pvid: cookie.get('pgv_pvid') || '',
                    appid: cookies ? cookies.main_login === 'qq' ? cookies.vqq_appid || cookies.appid : cookies.appid : '',
                    qq_openid: cookies && cookies.main_login === 'qq' ? cookies.vqq_openid || '' : '',
                    wx_openid: cookies && cookies.main_login === 'wx' ? cookies.openid : '',
                    qq: login.getUin(),
                    vuserid: login.getVuid(),
                    main_login: login.loginType()
                  }, baseParams), params));
                });
                instance.setUserInfo();
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function setPublicParams() {
        return _setPublicParams.apply(this, arguments);
      }
      return setPublicParams;
    }(),
    setUserInfo: function setUserInfo() {
      if (login.isLogin()) {
        var info = {
          dt_mainlogin_h5: login.loginType(),
          dt_qq_h5: login.getUin()
        };
        info["dt_".concat(login.loginType(), "openid_h5")] = login.getUid();
        reporter.setAccountInfo(info);
      } else {
        reporter.clearAccountInfo();
      }
    }
  };
  if (options.pageId) {
    reporter.setPage({
      pgid: options.pageId,
      contentid: "".concat(options.pageId, "_init")
    }, options.pageRoot || document.body).observe(options.pageId);
    reporter.initPage();
  }
  instance.setPublicParams();
  instance.setUserInfo();
  atom.on('onActionLoginFinish', instance.setPublicParams);
  atom.on('onActionLogoutFinish', instance.setPublicParams);
  atom.on('onSwitchLoginStateResponse', instance.setPublicParams);
  return instance;
}

/**
 * 获取基础上报公参
 */
var cacheBaseParams = null;
function getBaseParams() {
  return _getBaseParams.apply(this, arguments);
} /**
   * 格式化参数，转换为 boss 上报参数
   * @param {Object} params
   */
function _getBaseParams() {
  _getBaseParams = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var _yield$Promise$all, _yield$Promise$all2, appInfo, deviceInfo;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!cacheBaseParams) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", Promise.resolve(cacheBaseParams));
          case 2:
            _context2.next = 4;
            return Promise.all([atom.getAppInfo(), atom.getDeviceInfo()]);
          case 4:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            appInfo = _yield$Promise$all2[0];
            deviceInfo = _yield$Promise$all2[1];
            cacheBaseParams = {
              app_vr: appInfo.version || '',
              os_vrsn: deviceInfo.systemVersion || '',
              // APP 操作系统版本
              guid: deviceInfo.guid || '',
              // guid
              omgid: deviceInfo.omgid || '',
              jlbrk: deviceInfo.isJBOS || '0',
              hc_pvid: cookie.get('pgv_pvid') || ''
            };
            return _context2.abrupt("return", cacheBaseParams);
          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getBaseParams.apply(this, arguments);
}
function transform2boss(params) {
  if (params.f_module && params.f_resource) {
    return params;
  }
  return _objectSpread({
    f_module: params.mod_title,
    f_resource: params.btn_title,
    f_type: params.btn_title ? 4 : 1
  }, params);
}

/**
 * 格式化数据
 * @param {String|Object} data 参数
 * @param {Boolean} reportBoss 是否上报鹰眼
 */
var kvParser = new KVParser();
function parseParams(data) {
  var reportBoss = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (typeof data === 'string') {
    data = kvParser.parse(data);
  }
  if (reportBoss && (data.eid || data.mod_id || data.btn_title)) {
    return transform2boss(data);
  }
  return data;
}
function getParentContextParams(context) {
  // 通过Vue组件reportModule参数定义组件和子组件的f_module
  if (context.reportParams) {
    return context.reportParams;
  } else if (context.$options['reportParams']) {
    return context.$options['reportParams'];
  } else if (context.$options['reportModule']) {
    return {
      f_module: context.$options['reportModule']
    };
  } else if (context.$parent) {
    return getParentContextParams(context.$parent);
  } else {
    return undefined;
  }
}

// 处理一些参数定义不同的逻辑
function prefixParams(params) {
  if (params && !params.f_module && !params.f_type && params['模块']) {
    return params['模块'];
  }
  return params;
}

/**
 * 设置大同参数
 */
function setParams(el, params, vnode) {
  if (!params) {
    return;
  }
  var parentParams = getParentContextParams(vnode.context);
  params = prefixParams(_objectSpread(_objectSpread({
    business: 'hollywood'
  }, parentParams), params));
  el.setAttribute('dt-params', json2query(params));
  if (params.eid || params.f_hottag) {
    el.setAttribute('dt-eid', params.eid || params.f_hottag);
  }
}
function json2query() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var queryArr = [];
  if (!params.e_module_type || !params.f_module_type) {
    params.e_module_type = 'default';
  }
  for (var key in params) {
    var newKey = BOSS_DT_KEYMAP[key] || key;
    if (params.f_type === 1 && key === 'f_resource') {
      continue;
    }
    if (key === 'f_hottag' || key === 'eid') {
      continue;
    }
    if (newKey === 'e_module_type' && !params[key]) {
      // slide 滑动；tab tab式；default 常规
      params[newKey] = 'default';
    }
    queryArr.push("".concat(newKey, "=").concat(params[key]));
  }
  return queryArr.join('&');
}
function getScreenSize() {
  var size = {
    regular: 375,
    large: 667,
    huge: 980,
    max: 1366
  };
  var screenWidth = document.documentElement.clientWidth;
  var dpr = window.devicePixelRatio;
  var dpi;
  if (dpr > 1 && dpr < 3) {
    dpi = 2;
  } else if (dpr >= 3) {
    dpi = 3;
  } else {
    dpi = 1;
  }
  /*
    2020.5.12
    普通屏幕是160ppi，也就是我们常说的1倍屏幕。
    如果是320ppi，也就是我们常说的2倍屏幕。
    现在所有的设备都是160ppi+，高清的iphone XM 就是458ppi，虽然dpr是3，但其实是不够3倍屏的，所以还是以2倍屏来处理。
    2020.5.26
    有某些特殊的安卓机型dpr居然是4，所以有了以下判断，
  */
  if (dpr >= 4 && env.isAndroid) {
    dpr = 2;
  }
  dpi = 2;
  var index = Object.values(size).findIndex(function (el) {
    return el > dpr * screenWidth / dpi;
  }) - 1;
  if (index === -1) {
    index = 0;
  } else if (index === -2) {
    index = Object.values(size).length - 1;
  }
  return Object.keys(size)[index];
}